import { useEffect, useState } from "react";
const useAddContactFormHandler = (form, defaultValues, initialNumbers) => {
    const initialContactData = {
        isPrivate: defaultValues?.is_private || false,
        phoneNumbers: defaultValues &&
            defaultValues?.phones.map((phone) => phone.phone_number).length > 0
            ? defaultValues?.phones.map((phone) => phone.phone_number)
            : initialNumbers
                ? initialNumbers
                : [""],
        emailAddresses: defaultValues &&
            defaultValues?.emails.map((email) => email.email).length > 0
            ? defaultValues?.emails.map((email) => email.email)
            : [""],
        addresses: defaultValues?.addresses || [],
    };
    useEffect(() => {
        if (defaultValues) {
            form.setFieldsValue({
                first_name: defaultValues.first_name,
                middle_name: defaultValues.middle_name,
                last_name: defaultValues.last_name,
            });
        }
    }, []);
    const [isPrivateContact, setIsPrivateContact] = useState(initialContactData.isPrivate);
    const [numbers, setNumbers] = useState(initialContactData.phoneNumbers);
    const [emails, setEmails] = useState(initialContactData.emailAddresses);
    const [addresses, setAddresses] = useState(initialContactData.addresses);
    const handleAddNumber = () => {
        setNumbers([...numbers, ""]);
    };
    const handleAddEmail = () => {
        setEmails([...emails, ""]);
    };
    const handleEmailChange = (index, value) => {
        const updatedEmails = [...emails];
        updatedEmails[index] = value;
        setEmails(updatedEmails);
    };
    const handleRemoveEmail = (index) => {
        const updatedEmails = [...emails];
        updatedEmails.splice(index, 1);
        setEmails(updatedEmails);
    };
    const handleNumberChange = (index, value) => {
        const updatedNumbers = [...numbers];
        updatedNumbers[index] = value;
        setNumbers(updatedNumbers);
    };
    const handleRemoveNumber = (index) => {
        const updatedNumbers = [...numbers];
        updatedNumbers.splice(index, 1);
        setNumbers(updatedNumbers);
    };
    const handleAddressChange = (index, address) => {
        const updatedAddresses = [...addresses];
        updatedAddresses[index] = address;
        setAddresses(updatedAddresses);
    };
    const handleRemoveAddress = (index) => {
        const updatedAddresses = [...addresses];
        updatedAddresses.splice(index, 1);
        setAddresses(updatedAddresses);
    };
    const handleAddAddress = () => {
        setAddresses([
            ...addresses,
            {
                address1: "",
                address2: "",
                city: "",
                ZIP: "",
                state: "",
            },
        ]);
    };
    return {
        isPrivateContact,
        setIsPrivateContact,
        numbers,
        emails,
        addresses,
        handleAddNumber,
        handleAddEmail,
        handleEmailChange,
        handleRemoveEmail,
        handleNumberChange,
        handleRemoveNumber,
        handleAddAddress,
        handleRemoveAddress,
        handleAddressChange,
    };
};
export default useAddContactFormHandler;
